export default __webpack_public_path__ + "static/media/acceleZ.e447acb0.svg";